// extracted by mini-css-extract-plugin
module.exports = {"container":"SchoolsSection_container__22KuE","text":"SchoolsSection_text__Ju7B5","school-logos-container":"SchoolsSection_school-logos-container__A2mCB"};